import React from 'react'
import Popup from 'reactjs-popup'
import VehicleMakeModelImage from '../VehicleMakeModelImage'
import Button from '../Button';
import building_and_contents_graphic from '../../../assets/images/buildings-and-contents-graphic.png'
import { productTypes } from '../../utilities/enums';

const ConfirmationPopup = (props) => {

    const {
        image,
        title,
        content,
        buttons,
        visible,
        type,
    } = props

    return (
        <Popup className='popup-alert' closeOnEscape={false} open={visible} closeOnDocumentClick={false}>
            <div className="content-box content-box-is-padding-small content-box--is-no-margin content-box--is-confirmation-popup-wrapper">
                <div className="confirmation-popup-image-wrapper">
                    {type === productTypes.motor && <VehicleMakeModelImage image={image} />}
                    {type === productTypes.homeContents && <img src={building_and_contents_graphic} alt="Household Contents" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                </div>
                
                <h1 className="confirmation-popup-title">{title}</h1>
                <div className='confirmation-popup-text'>
                    {content}
                </div>
                <div className='confirmation-popup-button-wrapper'>
                    {buttons && buttons.map((button, index) => {
                        return <Button
                            key={index}
                            onClick={button.onClick}
                            title={button.title}
                            color={button.color}
                            idName={`confirmation-popup-${button.title.replace(/\s+/g, '-').toLowerCase()}-button`}

                        />
                    })}
                </div>
            </div>
        </Popup>
    )
}

export default ConfirmationPopup
